<template>
  <div id="data-deletion">
    <div class="hidden-sm-and-down">
      <PageHeader/>
    </div>
    <div class="hidden-md-and-up">
      <m-top/>
    </div>

    <div class="hidden-xs-only">
      <el-row type="flex" justify="center">
        <el-col :md="20" :lg="18" :xl="15">
          <div style="width: 100%; max-width: 1284px; margin: 0 auto; min-height:calc(100vh - 160px - 272px);" >
            <div class="policy-content">
              <div class="page-title">データ削除リクエスト手順</div>

              <div class="section">
                <div class="section-title">データ削除について</div>
                <div class="section-body">
                  <p>当院がInstagram Graph APIおよびFacebook Graph APIを通じて取得したデータについて、ユーザーは削除を申請することができます。</p>
                </div>
              </div>

              <div class="section">
                <div class="section-title">対象となるデータ</div>
                <div class="section-body">
                  <ul class="data-list">
                    <li>Instagram公開コメント情報</li>
                    <li>当院宛のダイレクトメッセージ</li>
                    <li>AI解析結果データ</li>
                    <li>LINE通知関連ログ</li>
                  </ul>
                </div>
              </div>

              <div class="section">
                <div class="section-title">削除申請方法</div>
                <div class="section-body">
                  <p>以下のいずれかの方法でご連絡ください。</p>
                </div>

                <div class="subsection">
                  <div class="subsection-title">方法1：メール</div>
                  <div class="subsection-body">
                    <p>件名に「データ削除依頼」と記載の上、以下の情報をご記入ください。</p>
                    <ul class="info-list">
                      <li>Instagramユーザー名</li>
                      <li>対象投稿URL</li>
                      <li>削除希望内容</li>
                    </ul>
                    <p class="contact-info"><strong>送付先：</strong>info@hope-medical.jp</p>
                  </div>
                </div>

                <div class="subsection">
                  <div class="subsection-title">方法2：Instagram DM</div>
                  <div class="subsection-body">
                    <p>当院公式Instagramアカウントへ「データ削除希望」と送信してください。</p>
                  </div>
                </div>
              </div>

              <div class="section">
                <div class="section-title">処理について</div>
                <div class="section-body">
                  <ul class="process-list">
                    <li>本人確認後、30日以内に削除対応いたします。</li>
                    <li>法令上保存義務があるデータは対象外となる場合があります。</li>
                    <li>削除完了後、確認通知を送信いたします。</li>
                  </ul>
                </div>
              </div>

              <div class="section">
                <div class="section-title">お問い合わせ窓口</div>
                <div class="section-body contact-section">
                  <div class="contact-item">
                    <span class="label">詳細は本ページ下部の署名欄をご確認ください。</span>
                    <span class="value"></span>
                  </div>
                </div>
              </div>

              <div class="section">
                <div class="section-title">制定日</div>
                <div class="section-body">
                  <p>2026年03月06日</p>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <PageFooter/>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
import MTop from '@/components/m/MTop'

export default {
  name: 'DataDeletion',
  components: {
    PageHeader,
    PageFooter,
    MTop
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
#data-deletion {
  .policy-content {
    padding: 40px 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif, 'Hiragino Sans', 'ヒラギノ角ゴシック';
    color: #333;
    line-height: 1.8;

    .page-title {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 40px;
      color: #1a1a1a;
      border-bottom: 2px solid #0066cc;
      padding-bottom: 15px;
    }

    .section {
      margin-bottom: 35px;

      .section-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 15px;
        color: #0066cc;
        padding-left: 12px;
        border-left: 4px solid #0066cc;
      }

      .section-body {
        margin-left: 12px;
        font-size: 14px;
        line-height: 1.8;

        p {
          margin-bottom: 12px;
          
          &:last-child {
            margin-bottom: 0;
          }
        }

        ul {
          list-style: none;
          padding-left: 0;

          li {
            padding-left: 24px;
            position: relative;
            margin-bottom: 8px;

            &:before {
              content: '●';
              position: absolute;
              left: 0;
              color: #0066cc;
            }
          }
        }
      }
    }

    .subsection {
      margin-left: 24px;
      margin-top: 20px;
      padding: 15px;
      background-color: #f9f9f9;
      border-left: 3px solid #0066cc;

      .subsection-title {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 12px;
        color: #0066cc;
      }

      .subsection-body {
        font-size: 14px;
        line-height: 1.7;

        p {
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .info-list {
          list-style: none;
          padding-left: 0;
          margin-bottom: 12px;

          li {
            padding-left: 24px;
            position: relative;
            margin-bottom: 6px;

            &:before {
              content: '○';
              position: absolute;
              left: 0;
              color: #666;
            }
          }
        }

        .contact-info {
          background-color: #f0f5ff;
          padding: 10px 12px;
          border-radius: 4px;
          margin: 10px 0 0 0;
          font-size: 13px;

          strong {
            color: #0066cc;
          }
        }
      }
    }

    .data-list,
    .process-list {
      list-style: none;
      padding-left: 0;

      li {
        padding-left: 24px;
        position: relative;
        margin-bottom: 8px;

        &:before {
          content: '●';
          position: absolute;
          left: 0;
          color: #0066cc;
        }
      }
    }

    .contact-section {
      .contact-item {
        display: flex;
        margin-bottom: 12px;
        font-size: 14px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          min-width: 140px;
          font-weight: 600;
          color: #0066cc;
        }

        .value {
          flex: 1;
          color: #666;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #data-deletion {
    .policy-content {
      padding: 20px 12px;

      .page-title {
        font-size: 24px;
        margin-bottom: 25px;
      }

      .section {
        margin-bottom: 25px;

        .section-title {
          font-size: 16px;
        }

        .section-body {
          font-size: 13px;
        }
      }

      .subsection {
        margin-left: 12px;
        padding: 12px;

        .subsection-title {
          font-size: 14px;
        }

        .subsection-body {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
